"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconCart = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M23.43 40.2h35.2L64.86 18H55.7L52.41 7.8l-13.73 4.45L40.56 18h-.65L36.52 7.8 22.8 12.25 24.68 18h-7.34l-1.52-6.09a6.76 6.76 0 0 0-6.48-5.2h-4.2v2.5h4.19a4.21 4.21 0 0 1 4.07 3.19l6.74 26.38a5.52 5.52 0 0 0-2.3 4.5 5.65 5.65 0 0 0 5.6 5.59h34.3v-2.55H23.43a3.06 3.06 0 0 1 0-6.12zM50.76 11l2.29 6.86h-9.91l-1.4-3.94zm-15.88 0l2.29 6.86h-9.91l-1.4-3.94zM18 20.38h43.56l-4.83 17.28H22.42zM46.57 52.66a5.34 5.34 0 0 0 0 10.68A5.29 5.29 0 0 0 51.91 58a5.37 5.37 0 0 0-5.34-5.34zm0 8.26a2.93 2.93 0 1 1 0-5.85A2.87 2.87 0 0 1 49.49 58a3 3 0 0 1-2.92 2.92zM27 52.66A5.34 5.34 0 1 0 32.33 58 5.37 5.37 0 0 0 27 52.66zm0 8.26A2.93 2.93 0 1 1 29.92 58 3 3 0 0 1 27 60.92z"
  })),
  height: undefined,
  width: undefined
});
IconCart.displayName = 'IconCart';
var _default = IconCart;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/cart.js
// module id = 223
// module chunks = 0